import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

export default function Faq() {
  const [active, setActive] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">问答 · FAQ</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于打包、完整版与下载
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
            常见口径一次说清，收藏前先看这里，能少走不少弯路。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((item, i) => {
            const open = active === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setActive(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-[15px] font-semibold text-foreground-950">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-200 ${open ? 'rotate-45 bg-primary-500 text-background-50' : ''}`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}